import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../../../../main/reports/components/Layout';
import Header from '../../../../main/reports/payouts/components/Header';
import List from './List';
import History from '../containers/HistoryContainer';

// eslint-disable-next-line react/prop-types
const Report = ({ fromDate, toDate, report, tipReport, lastPayoutDate, onLoadMore, hasMore, loading }) => (
  <Layout reportType="Payouts">
    <div className="c-wrapper o-page-height">
      <Header fromDate={fromDate} toDate={toDate} lastTransferDate={lastPayoutDate} />
      <List report={report} tipReport={tipReport} />
      <History onLoadMore={onLoadMore} hasMore={hasMore} loading={loading} />
    </div>
  </Layout>
);

Report.propTypes = {
  fromDate: PropTypes.string.isRequired,
  toDate: PropTypes.string.isRequired,
  onLoadMore: PropTypes.func,
  hasMore: PropTypes.bool,
  loading: PropTypes.bool,
};
Report.defaultProps = {
  onLoadMore: () => {},
  hasMore: false,
  loading: false,
};

export default Report;
